export enum TourType {
  REGULAR = 'REGULAR',
  WALKING = 'WALKING',
  DINING = 'DINING'
}
